module.exports = __webpack_public_path__ + "static/media/54524100_587105941776026_3208257127487373312_o.dd1599f7.jpg";